<template>
    <notifications group="progress" />
</template>

<script>
    export default {
        mounted() {
            window.notify = (msg, style = 'info') => {
              if (typeof msg === 'object') {
                msg.group = 'progress';
                msg.width = '400px';
                msg.duration = msg.duration ? msg.duration : 5000;

                this.$notify(msg);
              } else {
                this.$notify({
                  group: 'progress',
                  text: msg,
                  type: style,
                  width: '400px',
                  duration: 5000,
                });
              }
            };
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/Notify.vue